import { Grid2, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
    keyTitle: string;
    keyWidth?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

/**
 * Represents a key-value pair component.
 *
 * @param {Object} props - The props object containing the following properties:
 *   @param {string} keyTitle - The title of the key.
 *   @param {number} keyWidth - The width of the key column.
 *   @param {React.ReactNode} children - The content of the value column.
 *
 * @returns {React.ReactElement} The rendered key-value pair component.
 */
export default function Kvp({ keyTitle, keyWidth, children }: Props): React.ReactElement {
    return (
        <Grid2 container columnSpacing={0} alignItems={"center"}>
            <Grid2 size={keyWidth ?? 6} px={2}>
                <Typography fontWeight={"bold"}>{keyTitle}</Typography>
            </Grid2>
            <Grid2 size={keyWidth ? 12 - keyWidth : 6} px={2} display={"flex"} alignItems={"center"}>
                {typeof children == "string" ? <Typography variant={"body2"}>{children}</Typography> : children}
            </Grid2>
        </Grid2>
    );
}
